import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Type from "@actionTypes";
import { CloseOutlined } from '@ant-design/icons';
import './index.less';

const Tabs = (props) => {
  const { tabsList = [], activeKey, activeTab = {} } = useSelector((state) => state.menuInfo);
  const dispatch = useDispatch();
  const history = useHistory();
  const deleteTab = (tab, event) => {
    event.stopPropagation();
    let param = {}
    const keyList = tabsList.map(i => i.key);

    const keyIndex = keyList.indexOf(activeKey);
    //判断是列表还是详情
    const systemNum = tab.key?.split('-')?.[1]


    const newList = tabsList.filter(i => i.key !== tab.key);

    if (activeKey === tab.key) {
      param = {
        tabsList: newList,
        activeKey: newList[keyIndex > 1 ? keyIndex - 1 : 0]?.key || '',
        activeTab: newList[keyIndex > 1 ? keyIndex - 1 : 0]
      }
    } else {
      param = {
        tabsList: newList
      }
    }
    dispatch({
      type: Type.SPLICE_TABSLIST,
      param,
    })
    // 详情关闭 清空redux
    if (systemNum) {
      dispatch({
        type: Type.RESET_DETAIL,
        systemNum,
      })
    }else {
      // 列表关闭 清空redux
      dispatch({
        type: Type.RESET_CASEPOOL,
        roleKey: tab.key,
      });
    }




    if (newList.length > 0) {
      history.replace(newList[keyIndex - 1 > 0 ? keyIndex - 1 : 0].url)
    } else {
      dispatch({ type: Type.CLEAR_MENU })
      history.replace('/fagicCourt')
    }

  }
  const changeTab = child => {
    if (child.key !== activeKey) {
      dispatch({
        type: Type.MENU_CLICK,
        child,
        url: child.url,
      })
      history.replace(child.url)
    }
  }
  useEffect(() => {
    const beforeunload = (e) => {
      sessionStorage.setItem('tabsList', JSON.stringify(tabsList))
      sessionStorage.setItem('activeKey', activeKey)
      sessionStorage.setItem('activeTab', JSON.stringify(activeTab))
    };
    // 拦截判断是否离开当前页面
    window.addEventListener('beforeunload', beforeunload);
    return () => window.removeEventListener('beforeunload', beforeunload)
  }, [tabsList, activeKey, activeTab])
  useEffect(() => {
    if (tabsList.length === 0) {
      history.replace('/fagicCourt')
    }
  }, [tabsList])
  return (
    <div key="tabs" className="tabs" style={tabsList.length === 0 ? { display: 'none' } : {}}>
      <div className="tabs-nav">
        {
          tabsList.map(tab =>
            <div
              key={tab.key}
              className="header-tab"
              onClick={() => changeTab(tab)}
              style={activeKey === tab.key ? {
                color: '#A42C22',
                fontWeight: 'bold',
                borderBottom: '1px solid #FFFFFF'
              } : {}}
            >
              {tab.des}
              <CloseOutlined className="delete-ico" onClick={event => deleteTab(tab, event)}/>
            </div>)
        }
      </div>
    </div>
  );
}
export default Tabs;
